<template>
  <div>
    <div v-if="!loading">
      <div v-if="client" class="flex flex-col">
        <div class="card">
          <card-header :title="'Cliente #' + client.id">
          </card-header>

          <div v-if="client.profile_image" class="w-20 h-20 relative flex mb-4">
            <img
              ref="imagePreview"
              class="rounded-full object-cover object-center w-full h-full border border-primary-500"
              :src="client.profile_image.url"
            />
          </div>

          <section-header title="Información Personal" />

          <div class="detail-grid">
            <detail-field label="Nombre" :value="client.name + ' ' + client.last_name" />

            <detail-field label="Correo">
              <a
                :href="`mailto:${client.user.email}`"
                class="detail-link"
                >{{ client.user.email }}</a
              >
            </detail-field>

            <detail-field label="Autenticación" :value="client.user.external_auth ? capitalizeFirstLetter(client.user.external_auth) : 'Correo'" />

            <detail-field label="Teléfono">
              <a
                :href="`https://api.whatsapp.com/send?phone=${client.phone}`"
                target="_blank"
                class="detail-link"
              >
                {{ client.phone }}
              </a>
            </detail-field>

            <detail-field label="Género" :value="client.gender" />
            <detail-field label="Fecha de nacimiento" :value="formatDate(client.birthdate)" />
            <detail-field label="Fecha de creación" :value="formatDatetime(client.created_at)" />
            <detail-field label="Fecha de última actualización" :value="formatDatetime(client.updated_at)" />
          </div>

          <section-header title="Mascotas" />

          <div class="flex flex-wrap gap-2">
            <div v-for="pet in client.pets" :key="pet.id">
              <router-link
                :to="{
                  name: 'petsDetail',
                  params: { id: pet.id },
                }"
                class="detail-link"
                >{{ pet.name }}</router-link
              >
            </div>
          </div>

          <section-header title="Planes" />

          <div class="flex flex-wrap gap-2">
            <div v-for="quote in client.quotes" :key="quote.id">
              <router-link
                :to="{
                  name: 'quotesDetail',
                  params: { id: quote.id },
                }"
                class="detail-link"
                >{{ getPlanName(quote) }}</router-link
              >
            </div>
          </div>

          <section-header title="Cuestionario" />

          <div class="detail-grid">
            <detail-field label="Beneficios esperados">
              <p v-for="benefit in getExpectations('benefit')" :key="benefit.id" class="detail-value">
                - {{ benefit.value }}
              </p>
            </detail-field>

            <detail-field v-if="getExpectations('barf_opinion')[0]" label="Opinión sobre dieta BARF" :value="getExpectations('barf_opinion')[0].value" />

            <detail-field v-if="getExpectations('bond')[0]" label="Vínculo con mascota" :value="getExpectations('bond')[0].value" />
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Client Detail",

  data() {
    return {
      client: null,
      loading: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "clients");

    this.loadClient();
  },

  methods: {
    formatDate,

    formatDatetime,

    async loadClient() {
      this.loading = true;

      try {
        this.client = await api.clients.getById(this.$route.params.id);
        this.$store.commit('setBreadcrumbLabel', {
          routeName: this.$route.name,
          label: this.client.name + ' ' + this.client.last_name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: "clientsIndex" });
      }

      this.loading = false;
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    getExpectations(key) {
      return this.client.expectations.filter((ex) => ex.type === key);
    },

    getPlanName(quote) {
      const petNames = quote.diets
        .map((diet) => diet.pet?.name)
        .filter(Boolean)
        .join(" - ");

      return `#${quote.id} / ${petNames}`;
    },
  },
};
</script>